import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { safeFetch } from '../utils/apiUtils';

const TrafficTracker = () => {
    const location = useLocation();

    useEffect(() => {
        // Exclude admin pages from tracking
        if (location.pathname.startsWith('/admin')) {
            return;
        }

        const trackVisit = async () => {
            console.log('Attempting to track visit to:', location.pathname);
            try {
                const visitData = {
                    path: location.pathname,
                    referrer: document.referrer || 'direct',
                    timestamp: new Date().toISOString(),
                    userAgent: navigator.userAgent,
                    screenResolution: `${window.screen.width}x${window.screen.height}`,
                    language: navigator.language
                };

                const response = await safeFetch('https://aayushrealproperties.in/nimaibackend/public/api/track-visit', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    },
                    body: JSON.stringify(visitData)
                });
                console.log('Track visit response:', response);
            } catch (error) {
                console.error('Traffic tracking failed:', error);
            }
        };

        trackVisit();
    }, [location]);

    return null; // This component doesn't render anything
};

export default TrafficTracker;
